/* src/app/order/components/company-general-info/shifts-number/shifts-number.style.scss */
.shifts-number {
  display: flex;
  flex-direction: column;
}
.shifts-number .shifts-number-input {
  display: flex;
  justify-content: space-between;
}
.shifts-number .shifts-number-input .shifts-radio-buttons nb-radio-group {
  display: flex !important;
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
.shifts-number .shifts-number-input .shifts-radio-buttons nb-radio {
  display: inline-block !important;
}
.shifts-number .shifts-number-input .more-shifts {
  width: 150px;
  min-width: 120px;
}
/*# sourceMappingURL=shifts-number.style.css.map */
